import { render, staticRenderFns } from "./SendEmailForRestorePassword.vue?vue&type=template&id=26d86420&scoped=true&"
import script from "./SendEmailForRestorePassword.vue?vue&type=script&lang=js&"
export * from "./SendEmailForRestorePassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d86420",
  null
  
)

export default component.exports